import { FONT_COLOR, BG_COLOR } from './general'
import { RAIN_COLOR, RISK_COLOR, SOIL_RISK_COLOR, BSN_RISK_COLOR } from './color'

const SOIL_RISK_COLOR_DEFAULT = '#775DD0'

const SOIL_RISK_LABEL = {
    style: {
        background: SOIL_RISK_COLOR_DEFAULT,
        color: '#fff',
    },
    text: '被災危険域'
}

const IMPACT_RISK_LABEL = {
    style: {
        background: BG_COLOR,
        borderColor: 'transparent',
        borderWidth: 0,
        color: FONT_COLOR,
        boxShadow: 'none',
    },
    text: '被災危険域'
}

export const SOIL_RISK_X_2000 = {
    xaxis: [
        {
            x: 2000,
            borderColor: SOIL_RISK_COLOR_DEFAULT,
            label: SOIL_RISK_LABEL
        }
    ]
}

export const SOIL_RISK_X_0_2000 = {
    xaxis: [
        {
            x: 2000,
            borderColor: FONT_COLOR,
            label: SOIL_RISK_LABEL
        },
        {
            x: 0,
            borderColor: '#fff',
            strokeDashArray: 0,
            width: '0.2px',
        }
    ]
}

export const LANDSLIDE_IMPACT_X_0_2000 = {
    xaxis: [
        {
            x: 2000,
            label: IMPACT_RISK_LABEL
        },
        {
            x: 0,
            borderColor: '#fff',
            strokeDashArray: 0,
            width: '0.2px',
        }
    ]
}

export const FLOOD_IMPACT_X_0_15 = {
    xaxis: [
        {
            x: 15,
            label: IMPACT_RISK_LABEL
        },
        {
            x: 0,
            borderColor: '#fff',
            strokeDashArray: 0,
            width: '0.2px',
        }
    ]
}
export const SOIL_RISK_Y_2000 = {
    y: 2000,
    borderColor: SOIL_RISK_COLOR_DEFAULT,
    label: SOIL_RISK_LABEL
}

export const LANDSLIDE_IMPACT_Y_2000 = {
    y: 2000,
    borderColor: FONT_COLOR,
    label: IMPACT_RISK_LABEL
}

export const FLOOD_IMPACT_Y_15 = {
    y: 15,
    borderColor: FONT_COLOR,
    label: IMPACT_RISK_LABEL
}

export const RIVER_X_0_15 = {
    xaxis: [
        {
            x: 0,
            borderColor: '#fff',
            strokeDashArray: 0,
            width: '0.2px',
        }
    ]
}

export const RAIN_Y_4LINES =(POINT)=> [
    {
        y: POINT.LEVEL_4,
        borderColor: RAIN_COLOR.LEVEL_5.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: String(POINT.LEVEL_4),
            offsetX: 5,
            position: 'left',
            style: {
                color: RAIN_COLOR.LEVEL_5.font_color,
                background: RAIN_COLOR.LEVEL_5.color,
            }
        }
    },
    {
        y: POINT.LEVEL_5,
        borderColor: RAIN_COLOR.LEVEL_6.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: String(POINT.LEVEL_5),
            position: 'left',
            offsetX: 5,
            style: {
                color: RAIN_COLOR.LEVEL_6.font_color,
                background: RAIN_COLOR.LEVEL_6.color,
            }
        }
    },
    {
        y: POINT.LEVEL_6,
        borderColor: RAIN_COLOR.LEVEL_7.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: String(POINT.LEVEL_6),
            position: 'left',
            offsetX: 5,
            style: {
                color: RAIN_COLOR.LEVEL_7.font_color,
                background: RAIN_COLOR.LEVEL_7.color,
            }
        }
    },
    {
        y: POINT.LEVEL_7,
        borderColor: RAIN_COLOR.LEVEL_8.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: String(POINT.LEVEL_7),
            position: 'left',
            offsetX: 5,
            style: {
                color: '#fff',
                color: RAIN_COLOR.LEVEL_8.font_color,
                background: RAIN_COLOR.LEVEL_8.color,
            }
        }
    }
]

export const RISK_Y_4LINES =(POINT)=> [
    {
        y: POINT.LEVEL_1,
        borderColor: RISK_COLOR.LEVEL_2.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: RISK_COLOR.LEVEL_2.label,
            // offsetX: RISK_COLOR.LEVEL_2.label.length + (RISK_COLOR.LEVEL_2.label.length * 5),
            offsetX: 15,
            position: 'left',
            style: {
                color: RISK_COLOR.LEVEL_2.font_color,
                background: RISK_COLOR.LEVEL_2.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_2,
        borderColor: RISK_COLOR.LEVEL_3.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: RISK_COLOR.LEVEL_3.label,
            // offsetX: RISK_COLOR.LEVEL_3.label.length * 8,
            offsetX: 15,
            position: 'left',
            style: {
                color: RISK_COLOR.LEVEL_3.font_color,
                background: RISK_COLOR.LEVEL_3.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_3,
        borderColor: RISK_COLOR.LEVEL_4.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: RISK_COLOR.LEVEL_4.label,
            offsetX: 37,
            position: 'left',
            // offsetX: RISK_COLOR.LEVEL_4.label.length * 8,
            style: {
                color: RISK_COLOR.LEVEL_4.font_color,
                background: RISK_COLOR.LEVEL_4.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_4,
        borderColor: RISK_COLOR.LEVEL_5.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: RISK_COLOR.LEVEL_5.label,
            offsetX: 15,
            position: 'left',
            // offsetX: RISK_COLOR.LEVEL_5.label.length * 8,
            style: {
                color: RISK_COLOR.LEVEL_5.font_color,
                background: RISK_COLOR.LEVEL_5.color,
                fontFamily: 'monospace',
            }
        }
    }
]

export const BSN_RISK_Y_4LINES =(POINT)=> [
    {
        y: POINT.LEVEL_1,
        borderColor: BSN_RISK_COLOR.LEVEL_2.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: BSN_RISK_COLOR.LEVEL_2.label,
            // offsetX: BSN_RISK_COLOR.LEVEL_2.label.length + (BSN_RISK_COLOR.LEVEL_2.label.length * 5),
            offsetX: 15,
            position: 'left',
            style: {
                color: BSN_RISK_COLOR.LEVEL_2.font_color,
                background: BSN_RISK_COLOR.LEVEL_2.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_2,
        borderColor: BSN_RISK_COLOR.LEVEL_3.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: BSN_RISK_COLOR.LEVEL_3.label,
            // offsetX: BSN_RISK_COLOR.LEVEL_3.label.length * 8,
            offsetX: 15,
            position: 'left',
            style: {
                color: BSN_RISK_COLOR.LEVEL_3.font_color,
                background: BSN_RISK_COLOR.LEVEL_3.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_3,
        borderColor: BSN_RISK_COLOR.LEVEL_4.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: BSN_RISK_COLOR.LEVEL_4.label,
            offsetX: 37,
            position: 'left',
            // offsetX: BSN_RISK_COLOR.LEVEL_4.label.length * 8,
            style: {
                color: BSN_RISK_COLOR.LEVEL_4.font_color,
                background: BSN_RISK_COLOR.LEVEL_4.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_4,
        borderColor: BSN_RISK_COLOR.LEVEL_5.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: BSN_RISK_COLOR.LEVEL_5.label,
            offsetX: 15,
            position: 'left',
            // offsetX: BSN_RISK_COLOR.LEVEL_5.label.length * 8,
            style: {
                color: BSN_RISK_COLOR.LEVEL_5.font_color,
                background: BSN_RISK_COLOR.LEVEL_5.color,
                fontFamily: 'monospace',
            }
        }
    }
]

const LANDSLIDE_RISK_LABEL = {
    style: {
        background: BG_COLOR,
        borderColor: 'transparent',
        borderWidth: 0,
        color: FONT_COLOR,
        boxShadow: 'none',
    },
    text: '土砂災害危険域'
}

export const LANDSLIDE_Y_2000 = {
    y: 2000,
    borderColor: FONT_COLOR,
    label: LANDSLIDE_RISK_LABEL
}

export const LANDSLIDE_X_0_2000 = {
    xaxis: [
        {
            x: 2000,
            label: LANDSLIDE_RISK_LABEL
        },
        {
            x: 0,
            borderColor: '#fff',
            strokeDashArray: 0,
            width: '0.2px',
        }
    ]
}

export const SOIL_Y_4LINES =(POINT)=> [
    {
        y: POINT.LEVEL_1,
        borderColor: SOIL_RISK_COLOR.LEVEL_2.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: SOIL_RISK_COLOR.LEVEL_2.label,
            offsetX: 85,
            position: 'left',
            style: {
                color: SOIL_RISK_COLOR.LEVEL_2.font_color,
                background: SOIL_RISK_COLOR.LEVEL_2.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_3,
        borderColor: SOIL_RISK_COLOR.LEVEL_4.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: SOIL_RISK_COLOR.LEVEL_4.label,
            offsetX: 95,
            position: 'left',
            style: {
                color: SOIL_RISK_COLOR.LEVEL_4.font_color,
                background: SOIL_RISK_COLOR.LEVEL_4.color,
                fontFamily: 'monospace',
            }
        }
    },
    {
        y: POINT.LEVEL_4,
        borderColor: SOIL_RISK_COLOR.LEVEL_5.color,
        borderWidth: 1.5,
        strokeDashArray: 4,
        label: {
            text: SOIL_RISK_COLOR.LEVEL_5.label,
            offsetX: 95,
            position: 'left',
            style: {
                color: SOIL_RISK_COLOR.LEVEL_5.font_color,
                background: SOIL_RISK_COLOR.LEVEL_5.color,
                fontFamily: 'monospace',
            }
        }
    }
]

export const SR_Y_4LINES = (POINT) => {
    const L2 = POINT.LEVEL_2;
    const L3 = POINT.LEVEL_3;
    const L4 = POINT.LEVEL_4;
    const L5 = POINT.LEVEL_5;

    const lines = [];

    // L2の基準線（nullでない場合のみ追加）
    if (L2 != null) {
        lines.push({
            y: L2,
            borderColor: SOIL_RISK_COLOR.LEVEL_2.color,
            borderWidth: 1.5,
            strokeDashArray: 4,
            label: {
                text: SOIL_RISK_COLOR.LEVEL_2.label,
                position: 'left',
                textAnchor: 'start',
                style: {
                    color: SOIL_RISK_COLOR.LEVEL_2.font_color,
                    background: SOIL_RISK_COLOR.LEVEL_2.color,
                    fontFamily: 'monospace',
                }
            }
        });
    }

    // L3の基準線（nullでない場合のみ追加）
    if (L3 != null) {
        lines.push({
            y: L3,
            borderColor: SOIL_RISK_COLOR.LEVEL_3.color,
            borderWidth: 1.5,
            strokeDashArray: 4,
            label: {
                text: SOIL_RISK_COLOR.LEVEL_3.label,
                position: 'left',
                textAnchor: 'start',
                style: {
                    color: SOIL_RISK_COLOR.LEVEL_3.font_color,
                    background: SOIL_RISK_COLOR.LEVEL_3.color,
                    fontFamily: 'monospace',
                }
            }
        });
    }

    // L4の基準線（nullでない場合のみ追加）
    if (L4 != null) {
        lines.push({
            y: L4,
            borderColor: SOIL_RISK_COLOR.LEVEL_4.color,
            borderWidth: 1.5,
            strokeDashArray: 4,
            label: {
                text: SOIL_RISK_COLOR.LEVEL_4.label,
                position: 'left',
                textAnchor: 'start',
                style: {
                    color: SOIL_RISK_COLOR.LEVEL_4.font_color,
                    background: SOIL_RISK_COLOR.LEVEL_4.color,
                    fontFamily: 'monospace',
                }
            }
        });
    }

    // L5の基準線（nullでない場合のみ追加）
    if (L5 != null) {
        lines.push({
            y: L5,
            borderColor: SOIL_RISK_COLOR.LEVEL_5.color,
            borderWidth: 1.5,
            strokeDashArray: 4,
            label: {
                text: SOIL_RISK_COLOR.LEVEL_5.label,
                position: 'left',
                textAnchor: 'start',
                style: {
                    color: SOIL_RISK_COLOR.LEVEL_5.font_color,
                    background: SOIL_RISK_COLOR.LEVEL_5.color,
                    fontFamily: 'monospace',
                }
            }
        });
    }
    return lines;
}